var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenHandshake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.85,
    height: 24.676,
    viewBox: "0 0 30.85 24.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hands-helping",
    "data-name": "Icon awesome-hands-helping",
    d: "M23.521,9.255H16.195v2.7a3.47,3.47,0,0,1-6.941,0V6.093L6.126,7.973a3.078,3.078,0,0,0-1.5,2.641v2.28L.771,15.121a1.539,1.539,0,0,0-.564,2.106l3.856,6.681a1.543,1.543,0,0,0,2.106.564l4.984-2.878h6.584a3.088,3.088,0,0,0,3.085-3.085h.771a1.541,1.541,0,0,0,1.542-1.542V13.882h.386a1.154,1.154,0,0,0,1.157-1.157V10.412A1.154,1.154,0,0,0,23.521,9.255Zm7.119-1.8L26.784.772A1.543,1.543,0,0,0,24.678.208L19.694,3.085H14.768a3.108,3.108,0,0,0-1.634.468L11.519,4.56A1.532,1.532,0,0,0,10.8,5.866v6.088a1.928,1.928,0,0,0,3.856,0V7.713h8.869a2.7,2.7,0,0,1,2.7,2.7v1.374l3.856-2.227a1.544,1.544,0,0,0,.564-2.106Z",
    transform: "translate(0.002 -0.002)",
    fill: "#6b9672"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHandshake);
export default __webpack_public_path__ + "static/media/greenHandshake.9b0ee6df.svg";
export { ForwardRef as ReactComponent };